import Dto from './dto';

export default class Client extends Dto {
  constructor(client) {
    super(client);
  }
}